/*!
 * Locale file
 * For a multilanguage application, you can
 * specify the languages you want to use here.
 */

import en from './en'
import es from './es'
import EN_US from './en-US'

export default {
  'en': en,  
  'es': es,
  'en-US': EN_US
}
